import { useState } from "react";
import { Button } from "src/@/components/ui/button";
import { Input } from "src/@/components/ui/input";
import { Label } from "src/@/components/ui/label";
import { Dialog, DialogTrigger, DialogContent, DialogTitle } from "src/@/components/ui/dialog";
import { ScrollArea } from "src/@/components/ui/scroll-area";
import getActionPesquisarChat from "src/actions/chats/getActionPesquisarChat";
import { formataNumeroCelular } from "src/utils/functions";

const MenuChannelChat = ({ open, onClose, cliente, user, onSelectChat }) => {
  const [listaContatos, setListaContatos] = useState([]);
  const [pesquisa, setPesquisa] = useState("");
  const [contatoWhatsappId, setContatoWhatsappId] = useState(null);
  const [modalAlerta, setModalAlerta] = useState(false);
  const [modalAlertaMensagem, setModalAlertaMensagem] = useState("");

  const pesquisarChat = async (value) => {
    try {
      setPesquisa(value);
      const data = {
        clienteId: cliente._id,
        search: value,
      };
      const result = await getActionPesquisarChat(data); // Substituir com a função de API correta
      setListaContatos(result.data.chats || []);
    } catch (error) {
      console.error(error);
    }
  };

  const validarInclusaoChatLead = (value) => {
    const { _id, direciona_usuarios, statusRoom } = value;
    const statusPermitidos = ["Finalizado", "Avaliando", "Geral"];

    if (statusPermitidos.includes(statusRoom)) {
      onSelectChat(value);
      setContatoWhatsappId(value);
    } else if (direciona_usuarios.length > 0 && direciona_usuarios.includes(user.id)) {
      onSelectChat(value);
      setContatoWhatsappId(value);
    } else {
      setModalAlerta(true);
      setModalAlertaMensagem(
        "Não é possível incluir esse chat, pois ele está em andamento com outro usuário. Por favor, escolha outro chat."
      );
      setContatoWhatsappId(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="w-[300px]">
        <DialogTitle>Escolher chat</DialogTitle>

        {modalAlerta && (
          <Dialog open={modalAlerta} onOpenChange={() => setModalAlerta(false)}>
            <DialogContent>
              <DialogTitle>Alerta</DialogTitle>
              <p className="text-sm text-muted-foreground">{modalAlertaMensagem}</p>
              <Button
                className="mt-4"
                onClick={() => {
                  setModalAlerta(false);
                  setModalAlertaMensagem("");
                }}
              >
                Fechar
              </Button>
            </DialogContent>
          </Dialog>
        )}

        <div className="space-y-2">
          <div>
            <Label htmlFor="search">Whatsapp</Label>
            <Input
              id="search"
              placeholder="Escolha um contato"
              value={pesquisa}
              onChange={(e) => {
                const value = e.target.value;
                setPesquisa(value);
                if (value.length > 3) {
                  pesquisarChat(value);
                } else {
                  setListaContatos([]);
                }
              }}
            />
          </div>
          <ScrollArea className="h-40 border rounded-md">
            {listaContatos.length > 0 ? (
              listaContatos.map((contato) => (
                <Button
                  key={contato._id}
                  variant="ghost"
                  className="w-full text-left"
                  onClick={() => {
                    validarInclusaoChatLead(contato);
                  }}
                >
                  {formataNumeroCelular(contato.numeroCliente)}
                </Button>
              ))
            ) : (
              <p className="text-sm text-muted-foreground p-2">
                Digite 5 caracteres para começar a pesquisar.
              </p>
            )}
          </ScrollArea>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MenuChannelChat;
